import { styled } from '@material-ui/core/styles';
import { Box, InputBase, withStyles } from '@material-ui/core';

export const Root = styled(Box)({
    '& .tableWapper': {
        width: '100%',
        // height: '600px',
        overflowX: 'auto',
        '& .table': {
            minWidth: '650px',
            '& .cell': {
                width: '16%',
            },
        },
    },
    '& .search': {
        height: '41px',
        color: '#58727C',
        backgroundColor: '#fff',
        borderRadius: 4,
        border: '1px solid #ced4da',
        marginLeft: '10px',
        '& .search-icon': {
            padding: '0 10px',
        },
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .btn': {
        width: '186px',
    },
});
export const BootstrapInput = withStyles({
    input: {
        width: '302px',
        borderRadius: 4,
        position: 'relative',
        backgroundColor: '#fff',
        border: '1px solid #ced4da',
        fontSize: 16,
        margin: '16px 0',
        padding: '10px',
        '&:focus': {
            borderRadius: 4,
            backgroundColor: '#fff',
        },
    },
})(InputBase);
